<div
  class="cut-off-time user-select-none"
  [cxPopover]="cutOffPopover"
>
  <span class="material-symbols-outlined fs-2">schedule</span>

  <ng-template #cutOffPopover>
    <p class="text-footnote ff-semibold text-uppercase mb-0">
      {{ 'product.cutOffTime' | translate }}
    </p>

    <p class="text-footnote text-uppercase mb-0">{{ time }}</p>
  </ng-template>
</div>
